import React from 'react';
import { number } from 'prop-types';

import NotNow from '../../assets/not_now.svg';
import AnotherAmount from '../../assets/other_amount.svg';
import Percent10 from '../../assets/10_percent.svg';
import Percent20 from '../../assets/20_percent.svg';
import Percent30 from '../../assets/30_percent.svg';

import styles from './styles.module.scss';

function TipSelection({ index }) {
  const iconList = {
    'without-tip': NotNow,
    1: Percent10,
    2: Percent20,
    3: Percent30,
    'input-tip': AnotherAmount
  };

  return (
    <div className={styles.tipIconContainer}>
      <img src={iconList[index]} alt={iconList[index]} />
    </div>
  );
}

TipSelection.defaultProps = {
  index: 'without-tip'
};

TipSelection.propTypes = {
  index: number
};

export default TipSelection;
